export const BASE_FRONT = "https://www.fhanred.com"
export const BASE_DASH =  "https://www.control.fhanred.com"


const RutasConfig = {
    BASE_FRONT,
    BASE_DASH
};

export default RutasConfig;